import React, { useEffect } from "react";
import { useDispatch, useSelector } from "react-redux";
import PageWrapper from "../PageWrapper";
import { PaddedPaper } from "../../components/paper";
import Grid from "@material-ui/core/Grid";
import ContentWrapper from "../../components/contentWrapper/contentWrapper";
import { isNotNullOrEmpty } from "../../utils/helpers/stringHelper";
import actions from "../../redux/client/actions";
import { useAccount } from "../../hooks/client";
import environmentSettings from "@constants/environmentSettings";

export function EziDebitForm() {
  const { clientData, accountId, payFullArrears } = useSelector((state) => state.Client);
  const { ezidebitUrl } = environmentSettings;
  const { arrearsValue } = useAccount(accountId) || {};
  const { clientDetails } = clientData;
  const { emailAddress, firstName, lastName, mobile } = clientDetails;
  const countryCode = "AU";

  const dispatch = useDispatch();

  useEffect(() => {
    return () => {
      dispatch(actions.clearAccountInfo());
    };
  }, [dispatch]);

  const getQueryStringForIFrameSrc = () => {
    let qs = `countryCode=${countryCode}`;
    if (accountId && isNotNullOrEmpty(accountId)) {
      qs = `${qs}&PaymentReference=${accountId}`;
    }
    if (firstName && isNotNullOrEmpty(firstName)) {
      qs = `${qs}&FirstName=${firstName}`;
    }
    if (lastName && isNotNullOrEmpty(lastName)) {
      qs = `${qs}&LastName=${lastName}`;
    }
    if (emailAddress && isNotNullOrEmpty(emailAddress)) {
      qs = `${qs}&EmailAddress=${clientDetails.emailAddress}`;
    }
    if (mobile && isNotNullOrEmpty(mobile)) {
      qs = `${qs}&MobilePhoneNumber=${clientDetails.mobile}`;
    }
    if (arrearsValue && isNotNullOrEmpty(arrearsValue) && (payFullArrears === true)) {
      qs = `${qs}&PaymentAmount=${arrearsValue}`;
    }
    return qs;
  };

  return (
    <PageWrapper>
      <PaddedPaper>
        <div className="page-wrapper page-wrapper-padded">
          <ContentWrapper>
            <Grid container spacing={2}>
              <Grid item xs={12} style={{ height: "100vh" }}>
                <iframe
                  title="Ezi Debit Payment Form"
                  src={`${ezidebitUrl}?${getQueryStringForIFrameSrc()}`}
                  desc="debitform"
                  height="100%"
                  width="100%"
                  style={{ border: "none" }}
                />
              </Grid>
            </Grid>
          </ContentWrapper>
        </div>
      </PaddedPaper>
    </PageWrapper>
  );
}
